/** D448 (R-26): why a rider contests a fare. */
export const FARE_CONTEST_REASON_CODES = ['FARE_TOO_HIGH', 'ROUTE_LONGER_THAN_NEEDED', 'CHARGED_MORE_THAN_RECEIPT', 'FINAL_FARE_REVISION', 'OTHER'];
export class RideCollaborationApi {
    client;
    constructor(client) {
        this.client = client;
    }
    // ---- delegation ----
    delegate(riderContactId) {
        return this.client.request({ method: 'POST', path: '/v1/ride-collaboration/delegations', body: { riderContactId }, auth: true });
    }
    consentDelegation(delegationId) {
        return this.client.request({ method: 'POST', path: `/v1/ride-collaboration/delegations/${encodeURIComponent(delegationId)}/consent`, body: {}, auth: true });
    }
    declineDelegation(delegationId) {
        return this.client.request({ method: 'POST', path: `/v1/ride-collaboration/delegations/${encodeURIComponent(delegationId)}/decline`, body: {}, auth: true });
    }
    revokeDelegation(delegationId) {
        return this.client.request({ method: 'POST', path: `/v1/ride-collaboration/delegations/${encodeURIComponent(delegationId)}/revoke`, body: {}, auth: true });
    }
    // ---- tracking share ----
    share(rideId, ttlMs) {
        return this.client.request({ method: 'POST', path: `/v1/rides/${encodeURIComponent(rideId)}/share`, body: { ttlMs }, auth: true });
    }
    resolveShare(token) {
        return this.client.request({ method: 'GET', path: `/v1/share/${encodeURIComponent(token)}`, auth: true });
    }
    revokeShare(token) {
        return this.client.request({ method: 'POST', path: `/v1/share/${encodeURIComponent(token)}/revoke`, body: {}, auth: true });
    }
    // ---- mutations ----
    mutate(rideId, kind, fareDelta) {
        return this.client.request({ method: 'POST', path: `/v1/rides/${encodeURIComponent(rideId)}/mutations`, body: { kind, fareDelta }, auth: true });
    }
    mutations(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/rides/${encodeURIComponent(rideId)}/mutations`, auth: true });
    }
    // ---- tips + disputes ----
    tip(rideId, amount) {
        return this.client.request({ method: 'POST', path: `/v1/rides/${encodeURIComponent(rideId)}/tip`, body: { amount }, auth: true });
    }
    /**
     * W8-HELP-CENTER (D448, R-26): the rider contests the fare of HIS completed ride — a stable reason code and an optional
     * comment (required with `OTHER`). `DISPUTE_RIDE_NOT_FOUND` 404, `DISPUTE_RIDE_NOT_COMPLETED` / `DISPUTE_ALREADY_OPEN` 409.
     */
    contestFare(rideId, input) {
        return this.client.request({ method: 'POST', path: `/v1/rides/${encodeURIComponent(rideId)}/disputes`, body: input, auth: true });
    }
    /** D448 (R-26): the rider's contests of one of his rides, and whether he may contest it now. */
    myFareContests(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/rides/${encodeURIComponent(rideId)}/disputes/mine`, auth: true });
    }
    reviewDispute(disputeId) {
        return this.client.request({ method: 'POST', path: `/v1/disputes/${encodeURIComponent(disputeId)}/review`, body: {}, auth: true });
    }
    /**
     * D469 (X-ray A-08): resolve with a credit in the RIDE's currency (never typed), at most its fare. 200 = resolved now;
     * 202 = above the alçada (the market threshold or the operator's own grant): the dispute stays open and the credit waits
     * in Finanças › Aprovações (`approval`) for a second operator.
     */
    resolveDisputeCredit(disputeId, input) {
        return this.client.request({ method: 'POST', path: `/v1/disputes/${encodeURIComponent(disputeId)}/resolve`, body: input, auth: true });
    }
    resolveDispute(disputeId, credit, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/disputes/${encodeURIComponent(disputeId)}/resolve`, body: { credit, reasonCode }, auth: true });
    }
    rejectDispute(disputeId) {
        return this.client.request({ method: 'POST', path: `/v1/disputes/${encodeURIComponent(disputeId)}/reject`, body: {}, auth: true });
    }
    /** One dispute by id (operator triage read, same `ride:cancel` gate as the actions). */
    getDispute(disputeId) {
        return this.client.request({ method: 'GET', path: `/v1/disputes/${encodeURIComponent(disputeId)}`, auth: true });
    }
    /** The operator dispute queue — `open` + `under_review` by default, oldest first; `states` narrows it. */
    listDisputes(query = {}) {
        const params = new URLSearchParams();
        if (query.states !== undefined && query.states.length > 0)
            params.set('state', query.states.join(','));
        if (query.limit !== undefined)
            params.set('limit', String(query.limit));
        const qs = params.toString();
        return this.client.request({ method: 'GET', path: `/v1/disputes${qs !== '' ? `?${qs}` : ''}`, auth: true });
    }
    finalCharge(rideId, baseMinor, currency) {
        return this.client.request({ method: 'GET', path: `/v1/rides/${encodeURIComponent(rideId)}/final-charge?baseMinor=${encodeURIComponent(baseMinor)}&currency=${encodeURIComponent(currency)}`, auth: true });
    }
}
//# sourceMappingURL=ride-collaboration.js.map